export enum WorkflowActionType {
  AccountAssignment = 'account_assignment',
  Comment = 'comment',
  AddSubscriber = 'add_subscriber',
}
